import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css'
import { createProvider } from './vue-apollo'
import VueApollo from 'vue-apollo'

import Element from 'element-ui'
import './element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'
import Timeline from 'timeline-vuejs'
import VueMoment from 'vue-moment'
import VueApexCharts from 'vue-apexcharts'
import VueSecureHTML from 'vue-html-secure'
import '@/permission'

import * as Sentry from '@sentry/vue'

Vue.use(Element, { locale })

Vue.use(Timeline)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.use(BootstrapVue)
Vue.use(VueMoment)
Vue.use(VueApexCharts)
Vue.use(VueSecureHTML)

Vue.component('Apexchart', VueApexCharts)

Vue.config.productionTip = false

const sentryEnabled = process.env.VUE_APP_SENTRY_ENABLED?.toLowerCase() === 'true'
if (sentryEnabled) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    tunnel: process.env.VUE_APP_SENTRY_TUNNEL,
    environment: process.env.NODE_ENV,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
      Sentry.replayIntegration({
        networkDetailAllowUrls: ['http://localhost:8082', 'https://totalng-staging.paragon-hub.com/api', 'https://totalng.paragon-hub.com/api'],
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false
      })
    ],
    beforeSend(event) {
      // Check if the error is a ChunkLoadError
      if (event.exception && event.exception.values) {
        const errorMessage = event.exception.values[0]?.value || ''
        const errorExceptions = [
          // Usually network errors are related to the user's internet connection
          // If they are not, we should see the error in the backend, not in the frontend
          'NetworkError',

          // This error should be ignored as well
          'ChunkLoadError',
          'Loading chunk',

          // This error is thrown when the user tries to navigate to the same page
          // This is a Vue Router error and should be ignored
          'Avoided redundant navigation',
          'Navigation cancelled',
          'Redirected when',

          // This error is thrown when the service worker encounter an error
          // This is a service worker error and should be ignored
          'ServiceWorker'
        ]

        if (errorExceptions.some((error) => errorMessage.includes(error))) {
          // Drop the event
          return null
        }
      }
      // Otherwise, send the event to Sentry
      return event
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['http://localhost:8082', 'https://totalng-staging.paragon-hub.com/api', 'https://totalng.paragon-hub.com/api'],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}
new Vue({
  router,
  store,
  i18n,
  apolloProvider: createProvider(),
  render: (h) => {
    return h(App)
  }
}).$mount('#app')

Vue.use(VueApollo)
